import { render, staticRenderFns } from "./CheckBoxItem.vue?vue&type=template&id=57b41a26&"
import script from "./CheckBoxItem.vue?vue&type=script&lang=js&"
export * from "./CheckBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports